// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Layout$PrezzeeRibbon from "../../../theme/Theme__Layout.bs.js";

var card = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.borderRadius(Theme__Layout$PrezzeeRibbon.Personal.borderRadius),
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.filter([{
              NAME: "dropShadow",
              VAL: [
                BsCssJs$PrezzeeRibbon.px(0),
                BsCssJs$PrezzeeRibbon.px(4),
                BsCssJs$PrezzeeRibbon.px(12),
                BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                      NAME: "num",
                      VAL: 0.1
                    })
              ]
            }])
    ]);

var Styles = {
  card: card
};

function Card(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: card
            });
}

var make = Card;

export {
  Styles ,
  make ,
}
/* card Not a pure module */
